import { defineStore } from "pinia";
import * as Types from '@/services/theme.service';

const useThemeStore = defineStore('theme', {
  /** @returns {{brand: Types.Theme | null}}*/
  state() {
    return { brand: null }
  },
  actions: {
    setTheme(theme) {
      this.brand = theme;
    },
    getMenuIcon() {
      return this.brand?.iconMenu ?? this.brand?.icon;
    },
    getLoginIcon() {
      return this.brand?.iconLogin ?? this.brand?.icon;
    }
  }
})

export default useThemeStore;
